<section class="page-center">
  <ng-container *ngIf="!(calculationAccess$ | async); then UnauthorizedCalculation">
  </ng-container>
  <ng-container *ngIf="(calculationInTrash$ | async) && (calculationAccess$ | async); then CalculationInTrash"></ng-container>
  <ng-container *ngIf="(calculationAccess$ | async) && !(calculationInTrash$ | async); then NotFoundTempRef"></ng-container>

</section>

<ng-template #NotFoundTempRef>
  <div class="row text-center">
    <div class="col-md-12">
      <figure>
        <img data-test="errorImg" src="assets/img/error404.svg" alt="error image" />
      </figure>
    </div>
    <div class="col-md-12">
      <h1 data-test="errorTitle">Oops!!</h1>
      <h3 data-test="errorMessage">{{ 'NOTFOUND.THISPAGENOTEXIST' | translate}}</h3>
    </div>
  </div>
</ng-template>

<ng-template #CalculationInTrash>
  <div class="text-center">
    <div class="mt-5">
      <i data-test="lockIcon" class='gpr-delete'></i>
    </div>
    <div class="my-5">
      <h1 data-test="unauthorizedErrorTitle" class="text-transform-none">{{ 'MESSAGES.TRASH_CALCULATION_TITLE' | translate}}</h1>
      <h3 data-test="unauthorizedErrorMessage">{{ 'MESSAGES.CALCULATION_IN_TRASH' | translate}}</h3>
    </div>
  </div>
</ng-template>

<ng-template #UnauthorizedCalculation>
  <div class="text-center">
    <div class="mt-5">
      <i data-test="lockIcon" class='gpr-lock'></i>
    </div>
    <div class="my-5">
      <h1 data-test="unauthorizedErrorTitle">{{'MESSAGES.ACCESS_RESTRICTED' | translate}}</h1>
      <h3 data-test="unauthorizedErrorMessage">{{ 'MESSAGES.UNAUTHORIZED_ACCESS' | translate}}</h3>
    </div>
  </div>
</ng-template>